import { apiRoutes } from '../../api-routes';
import { type AxiosRequestConfig, httpClient } from '../../util';
import type {
  IntercityPackageDetail,
  IntercityServiceRequest,
} from '../intercity/types';
import type { IntercityPath, ItemDescription } from '../place';

export interface CreateNewOrderRequestBody {
  service_id: string;
  path: IntercityPath[];
  requests: IntercityServiceRequest[];
  payment_method: string;
  total_pay?: number;
  order_time?: number;
  promo_code?: string;
  remarks?: string;
  admin_note?: string;
  parent_category?: string;
  route_optimized?: boolean;
  need_confirm?: boolean;
  idle_until?: number;
  items?: ItemDescription[];
  store_id?: number;
  suggest_promotion?: boolean;
  package_detail?: IntercityPackageDetail[];
}
export interface CreateNewOrderResponse {
  order_id: string;
}

export const createNewOrderFn = async (
  body: CreateNewOrderRequestBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<CreateNewOrderResponse>(
    apiRoutes.order.create,
    body,
    config
  );

  return response.data;
};
